'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { useSignUpFlowStore } from './use-sign-up-flow-store';
const STEP_OPTIONS = ['start', 'email-verification', 'choose'] as const;
const stepParser = parseAsStringLiteral(STEP_OPTIONS).withDefault('start');
export function useSignUpStepUrlSync() {
  const $ = _c(4);
  const [urlStep] = useQueryState("step", stepParser);
  const onChange = useSignUpFlowStore(_temp);
  let t0;
  let t1;
  if ($[0] !== onChange || $[1] !== urlStep) {
    t0 = () => {
      onChange({
        step: urlStep
      });
    };
    t1 = [urlStep, onChange];
    $[0] = onChange;
    $[1] = urlStep;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}
function _temp(s) {
  return s.onChange;
}